import { store } from "react-notifications-component";
import i18n from "../../i18n";
import offersApi from "./offersApi";
import offersTypes from "./offersTypes";

const offersActions = {
    getOffersForBranch: (branchId) => dispatch => {
        dispatch({ type: offersTypes.GET_OFFERS_LIST_PENDING });
        offersApi.getOffersForBranch(branchId)
            .then(res => {
                dispatch({
                    type: offersTypes.GET_OFFERS_LIST_SUCCESS,
                    payload: res.data,
                });
            })
            .catch((e) => {
                dispatch({ type: offersTypes.GET_OFFERS_LIST_ERROR });
                console.error('Error fetching offers:', e);
            });
    },

    createOffer: (branchId, data, callback) => dispatch => {
        dispatch({ type: offersTypes.CREATE_OFFER_PENDING });
        offersApi.createOffer(branchId, data)
            .then(res => {
                dispatch({
                    type: offersTypes.CREATE_OFFER_SUCCESS,
                    payload: res.data,
                });
                store.addNotification({
                    title: i18n.t('Notify.success'),
                    message: i18n.t('NSOffers.offerCreated') || 'Акция успешно создана',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                if (callback) callback();
            })
            .catch((e) => {
                dispatch({ type: offersTypes.CREATE_OFFER_ERROR });
                console.error('Error creating offer:', e);
            });
    },

    getCommunities: (params) => dispatch => {
        dispatch({ type: offersTypes.GET_COMMUNITIES_PENDING });
        offersApi.getCommunities(params)
            .then(res => {
                dispatch({
                    type: offersTypes.GET_COMMUNITIES_SUCCESS,
                    payload: res.data,
                });
            })
            .catch((e) => {
                dispatch({ type: offersTypes.GET_COMMUNITIES_ERROR });
                console.error('Error fetching communities:', e);
            });
    },

    updateOffer: (branchId, offerId, data, callback) => dispatch => {
        dispatch({ type: offersTypes.UPDATE_OFFER_PENDING });
        offersApi.updateOffer(branchId, offerId, data)
            .then(res => {
                dispatch({
                    type: offersTypes.UPDATE_OFFER_SUCCESS,
                    payload: res.data,
                });
                store.addNotification({
                    title: i18n.t('Notify.success'),
                    message: i18n.t('NSOffers.offerUpdated') || 'Акция успешно обновлена',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                if (callback) callback();
            })
            .catch((e) => {
                dispatch({ type: offersTypes.UPDATE_OFFER_ERROR });
                console.error('Error updating offer:', e);
            });
    },

    deleteOffer: (branchId, offerId, callback) => dispatch => {
        dispatch({ type: offersTypes.DELETE_OFFER_PENDING });
        offersApi.deleteOffer(branchId, offerId)
            .then(() => {
                dispatch({
                    type: offersTypes.DELETE_OFFER_SUCCESS,
                    payload: offerId,
                });
                store.addNotification({
                    title: i18n.t('Notify.success'),
                    message: i18n.t('NSOffers.offerDeleted') || 'Акция успешно удалена',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                if (callback) callback();
            })
            .catch((e) => {
                dispatch({ type: offersTypes.DELETE_OFFER_ERROR });
                console.error('Error deleting offer:', e);
            });
    },

    getOfferDetails: (branchId, offerId) => dispatch => {
        dispatch({ type: offersTypes.GET_OFFER_DETAILS_PENDING });
        offersApi.getOfferDetails(branchId, offerId)
            .then(res => {
                dispatch({
                    type: offersTypes.GET_OFFER_DETAILS_SUCCESS,
                    payload: res.data,
                });
            })
            .catch((e) => {
                dispatch({ type: offersTypes.GET_OFFER_DETAILS_ERROR });
                console.error('Error fetching offer details:', e);
            });
    },

    clearCurrentOffer: () => dispatch => {
        dispatch({ type: offersTypes.CLEAR_CURRENT_OFFER });
    },

    activateOffer: (branchId, offerId, callback) => dispatch => {
        dispatch({ type: offersTypes.ACTIVATE_OFFER_PENDING });
        offersApi.activateOffer(branchId, offerId)
            .then(res => {
                dispatch({
                    type: offersTypes.ACTIVATE_OFFER_SUCCESS,
                    payload: res.data,
                });
                store.addNotification({
                    title: i18n.t('Notify.success'),
                    message: i18n.t('NSOffers.offerActivated') || 'Акция успешно активирована',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                if (callback) callback();
            })
            .catch((e) => {
                dispatch({ type: offersTypes.ACTIVATE_OFFER_ERROR });
                console.error('Error activating offer:', e);
            });
    },

    suspendOffer: (branchId, offerId, callback) => dispatch => {
        dispatch({ type: offersTypes.SUSPEND_OFFER_PENDING });
        offersApi.suspendOffer(branchId, offerId)
            .then(res => {
                dispatch({
                    type: offersTypes.SUSPEND_OFFER_SUCCESS,
                    payload: res.data,
                });
                store.addNotification({
                    title: i18n.t('Notify.success'),
                    message: i18n.t('NSOffers.offerSuspended') || 'Акция успешно приостановлена',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                if (callback) callback();
            })
            .catch((e) => {
                dispatch({ type: offersTypes.SUSPEND_OFFER_ERROR });
                console.error('Error suspending offer:', e);
            });
    },
};

export default offersActions;
